import { useEffect } from 'react'

const useSetPageTitle = (title: string): void => {
  useEffect(() => {
    document.title = 'TPOS - ' + title
  }, [title])
}

export default useSetPageTitle
